import React from 'react';
import { Chart, Geom, Axis, Tooltip, Coord } from 'bizcharts';
import DataSet from '@antv/data-set';

const LineItemsDonut = ({ height, data, selectedDimension }) => {
  const { DataView } = DataSet;
  const dv = new DataView();

  dv.source(data);

  const cols = {
    impressions: { formatter: (val) => val.toLocaleString() },
    clicks: { formatter: (val) => val.toLocaleString() },
  };

  return (
    <div>
      <Chart forceFit data={dv} padding={'auto'} scale={cols} height={height / 1.1}>
        <Coord type="theta" radius={0.75} innerRadius={0.65} />
        <Axis name={selectedDimension} />

        <Tooltip showTitle={false} />

        <Geom
          color={[
            'value',
            (value) => {
              const index = data.findIndex((el) => el.value === value);
              if (data[index]) return data[index].color;
              else return 'black';
            },
          ]}
          position={selectedDimension}
          type="intervalStack"
        />
      </Chart>
    </div>
  );
};

export default LineItemsDonut;
